export default __webpack_public_path__ + "assets/backspace-icon-red.svg";